import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isSRPLoading: false,
  isSRPMapLoading: false,
  isPrintLoading: false,
  isDownloadLoading: false,
  srpInitData: {},
  saveSearch: {searchId: '', isSearchSaved: false},
  srpMapData: {},
  selectedProperty: null,
};

export const srpSlice = createSlice({
  name: "srp",
  initialState,
  reducers: {
    fetchSRPInitialLoad: (state, action) => {
      state.isSRPLoading = true;
      state.isSRPMapLoading = true;
      state.saveSearch.isSearchSaved = false;
      state.saveSearch.searchId = '';
    },
    setSRPInitialLoad: (state, action) => {
      state.isSRPLoading = action?.payload;
      state.isSRPMapLoading = action?.payload;
    },
    setPrintLoad: (state, action) => {
      state.isPrintLoading = action?.payload;
    },
    setDownloadLoad: (state, action) => {
      state.isDownloadLoading = action?.payload;
    },
    fetchSRPInitialLoadSuccess: (state, action) => {
      const {data, isNearBy} = action.payload;
      state.isSRPLoading = false;
      state.srpInitData = data;
      if (isNearBy) {
        state.srpInitData.srpTupples = data.srpTupples;
        state.srpInitData.totalResultCount = data?.totalResultCount || 0;
      }
    },
    setIsSaveSearch: (state, action) => {
      state.saveSearch.isSearchSaved = action.payload.isSearchSaved;
      state.saveSearch.searchId = action.payload.searchId;
    },
    updateFavorite: (state, action) => {
      state.srpInitData.srpTupples = action.payload;
    },
    fetchSRPMapSuccess: (state, action) => {
      const {data, isNearBy} = action.payload;
      state.isSRPMapLoading = false;
      state.srpMapData = data;
      if (isNearBy) {
        state.srpMapData.srpTupples = [...data.srpTupples, ...data.nearbySrpTupples];
        state.srpMapData.totalResultCount = (data?.totalResultCount || 0) + data.totalNearbyResultCount;
      }
    },
    fetchSRPInitialLoadFailure: (state) => {
      state.isSRPLoading = false;
      state.isSRPMapLoading = false;
      state.srpInitData = {};
      state.srpMapData = {};
      state.saveSearch.isSearchSaved = false;
      state.saveSearch.searchId = '';
    },
    setSelectedProperty: (state, action) => {
      state.selectedProperty = action.payload;
    },
    handleSRPLogout: (state) => {
      state.srpInitData.srpTupples = state?.srpInitData?.srpTupples?.length > 0 && state.srpInitData.srpTupples?.map(item => item?.onWatchList === 'Y' ? { ...item, onWatchList: 'N' } : item);
      state.saveSearch.isSearchSaved = false;
      state.saveSearch.searchId = '';
    }
  },
});

export const {
  fetchSRPInitialLoad,
  fetchSRPInitialLoadSuccess,
  fetchSRPInitialLoadFailure,
  fetchSRPMapSuccess,
  setSRPInitialLoad,
  setPrintLoad,
  setDownloadLoad,
  setSelectedProperty,
  setIsSaveSearch,
  updateFavorite,
  handleSRPLogout,
} = srpSlice.actions;

export const srpData = (state) => state.srp;
export default srpSlice.reducer;
